import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useContext } from "react";
import { Table, Modal } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import { useContractModel } from '../contractParticularsModel'
import { usecontractDetailsModel } from './detailsModel'
import { formatNum } from '@/erp_subpackage/utils/util';
import { getPcodeDict } from "@/utils/dataStorage"
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"
import { getCurrentCurrencySymbol } from '@/utils/currencyUtils';


export const BillDetailTable = () => {
    const {t} = useTranslation()
    const { setOpen } = useContractModel()
    const { loading, setDetailVisible, billTwo, contractPageT, searchParamt, code, updateSearchParamt, resetSearchParamt, pgCfgt, descTotalt, detailVisible,
    } = usecontractDetailsModel()
    const { getSelectedDictOne } = useDictModel()

    useEffect(() => {
        setOpen(false)
    })
    const column2 = [
        {
            title:  t(`contractManagement.view.detailModal.对账单单号`),
            width: 120,
            dataIndex: 'billCode',
            fixed: "left",
        },
        {
            title:  t(`contractManagement.view.detailModal.单据编号`),
            width: 140,
            dataIndex: 'orderCode',
            fixed: "left",
        },
        {
            title:  t(`contractManagement.view.detailModal.支付状态`),
            width: 120,
            dataIndex: 'payStatus',
            fixed: "left",
        }, {
            title:  t(`contractManagement.view.detailModal.工单类型`),
            width: 120,
            dataIndex: 'orderType',
            fixed: "left",
        },
        {
            title:  t(`contractManagement.view.detailModal.三包品牌`),
            width: 150,
            dataIndex: 'threeGuaranteesBrand',
        }, {
            title:  t(`contractManagement.view.detailModal.三包信息`),
            width: 280,
            dataIndex: 'threeGuaranteesInfo',

        }, {
            title:  t(`contractManagement.view.detailModal.工时费`),
            width: 100,
            dataIndex: 'hourlyWage',
            render: (text) => { return text.toFixed(2) }

        }, {
            title:  t(`contractManagement.view.detailModal.材料费`),
            width: 100,
            dataIndex: 'materialAmount',
            render: (text) => { return text.toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.detailModal.外出费`),
            width: 100,
            dataIndex: 'travelExpenses',
            render: (text) => { return text.toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.detailModal.餐补费`),
            width: 100,
            dataIndex: 'mealSupplement',
            render: (text) => { return text.toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.detailModal.其他费用`),
            width: 100,
            dataIndex: 'otherItemActualAmount',
            render: (text) => { return text.toFixed(2) }

        },
        {
            title:  t(`contractManagement.view.detailModal.三包工时费汇总`),
            width: 120,
            dataIndex: 'threeGuaranteesTotalHourlyWage',
            render: (text) => { return text.toFixed(2) }

        }, {
            title:  t(`contractManagement.view.detailModal.费用金额`),
            width: 100,
            dataIndex: 'totalAmount',
            render: (text) => { return text.toFixed(2) }

        }, {
            title:  t(`contractManagement.view.detailModal.预付款`),
            width: 100,
            dataIndex: 'prepayments',
            render: (text) => { return text.toFixed(2) }

        }, {
            title:  t(`contractManagement.view.detailModal.已收金额`),
            width: 100,
            dataIndex: 'paidAmount',
            render: (text) => { return text.toFixed(2) }
        }, {
            title:  t(`contractManagement.view.detailModal.应收金额`),
            width: 100,
            dataIndex: 'payableAmount',
            render: (text) => { return text.toFixed(2) }

        }, {
            title:  t(`contractManagement.view.detailModal.车辆牌照`),
            width: 100,
            dataIndex: 'vehicleCode',

        }, {
            title:  t(`contractManagement.view.detailModal.VIN码`),
            width: 180,
            dataIndex: 'vehicleVin',

        }, {
            title:  t(`contractManagement.view.detailModal.结算方`),
            width: 180,
            dataIndex: 'settlementParty',

        }, {
            title:  t(`contractManagement.view.detailModal.出账日期`),
            width: 180,
            dataIndex: 'billDate',

        }, {
            title:  t(`contractManagement.view.detailModal.开单日期`),
            width: 180,
            dataIndex: 'createTime',

        }, {
            title:  t(`contractManagement.view.detailModal.结算日期`),
            width: 180,
            dataIndex: 'settlementTime',

        }, {
            title:  t(`contractManagement.view.detailModal.核销日期`),
            width: 180,
            dataIndex: 'writeOffTime',

        },
    ]

    const searchFields1 = [
        {
            type: "Select",
            placeholder:  t(`contractManagement.view.detailModal.支付状态`),
            fieldName: "payStatus",
            options: [{ label:  t(`contractManagement.view.detailModal.已记账`), value: 'pay-status.bill', key: "pay-status.bill" }, { label:  t(`contractManagement.view.detailModal.已核销`), value: 'pay-status.write-off', key: "pay-status.write-off" }]

        },
        {
            type: "Input",
            placeholder:  t(`contractManagement.view.detailModal.车辆牌照`),
            fieldName: "vehicleCode"
        },
        {
            type: "Input",
            placeholder:  t(`contractManagement.view.detailModal.三包信息`),
            fieldName: "threeGuaranteesInfo"
        }, {
            type: "Select",
            placeholder:  t(`contractManagement.view.detailModal.工单类型`),
            fieldName: "orderType",
            options: getPcodeDict('014').children.map(item => {
                return ({ label: item.title, value: item.dictCode, key: item.id })
            }),
        }, {
            type: "Select",
            placeholder:  t(`contractManagement.view.detailModal.结算方`),
            fieldName: "settlementParty",
            options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY)
        },

        {
            type: "Input",
            placeholder:  t(`contractManagement.view.detailModal.单据编号`),
            fieldName: "orderCode"
        },

    ]

    const searchMoreFields = [
        {
            type: "Datepicker",
            placeholder:  t(`contractManagement.view.detailModal.出账日期`),
            fieldName: "billDate"
        },
        {
            type: "Datepicker",
            placeholder:  t(`contractManagement.view.detailModal.结算日期`),
            fieldName: "settlementTime"
        },
        {
            type: "Datepicker",
            placeholder:  t(`contractManagement.view.detailModal.开单日期`),
            fieldName: "createTime"
        }, {
            type: "Datepicker",
            placeholder:  t(`contractManagement.view.detailModal.核销日期`),
            fieldName: "writeOffTime"
        },

    ]


    const desc1 = [
        {
            label:  t(`contractManagement.view.detailModal.工时费`),
            value: getCurrentCurrencySymbol() + (descTotalt.hourlyWage ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.detailModal.材料费`),
            value: getCurrentCurrencySymbol() + (descTotalt.materialAmount ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.detailModal.外出费`),
            value: getCurrentCurrencySymbol() + (descTotalt.travelExpenses ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.detailModal.餐补费`),
            value: getCurrentCurrencySymbol() + (descTotalt.mealSupplement ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.detailModal.三包工时汇总`),
            value: getCurrentCurrencySymbol() + (descTotalt.threeGuaranteesTotalHourlyWage ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.detailModal.费用金额`),
            value: getCurrentCurrencySymbol() + (descTotalt.totalAmount ?? 0).toFixed(2),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.detailModal.预付款`),
            value: getCurrentCurrencySymbol() + (descTotalt.prepayments ?? 0).toFixed(2),
            color: "red"
        }, {
            label:  t(`contractManagement.view.detailModal.已收金额`),
            value: getCurrentCurrencySymbol() + (descTotalt.paidAmount ?? 0).toFixed(2),
            color: "red"
        }, {
            label:  t(`contractManagement.view.detailModal.应收金额`),
            value: getCurrentCurrencySymbol() + (descTotalt.payableAmount ?? 0).toFixed(2),
            color: "red"
        },
    ]

    return (
        <>
            <Modal
                title= { t(`contractManagement.view.detailModal.对账单明细`)}
                open={detailVisible}
                visible={detailVisible}
                onCancel={() => setDetailVisible(false)}
                width={1800}
                footer={[]}
            >
                <YhBox descriptions={desc1} >
                    <YhPageHeader
                        size="small"
                        justify="start"
                        triggerSearch
                        searchValues={searchParamt}
                        searchFields={searchFields1}
                        searchMoreFields={searchMoreFields}
                        onChange={updateSearchParamt}
                        handleSearch={() => { contractPageT({ pageNum: 1 }, { ...searchParamt, billCode: code }) }}
                        handleReset={resetSearchParamt}
                    />
                    <div>
                        <Table
                            columns={column2}
                            loading={loading}
                            dataSource={billTwo}
                            pagination={{
                                ...pgCfgt,
                                position: ["bottomCenter"],
                                showTotal: () => `${ t(`contractManagement.view.detailModal.共`)}${pgCfgt.total}${ t(`contractManagement.view.detailModal.条`)}`,
                                onChange: (pageNum, pageSize) => {
                                    contractPageT({ pageNum, pageSize });
                                }
                            }}
                            scroll={{ y: 800 }}
                        />
                    </div>
                </YhBox>
            </Modal>
        </>

    )

}